import { render, staticRenderFns } from "./appointments-doctor-card.vue?vue&type=template&id=482a22c2"
import script from "./appointments-doctor-card.vue?vue&type=script&lang=js"
export * from "./appointments-doctor-card.vue?vue&type=script&lang=js"
import style0 from "./appointments-doctor-card.vue?vue&type=style&index=0&id=482a22c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports